import { Grid, Stack, Typography } from "@mui/material";
import CustomButton from "components/atoms/CustomButton";

import React from "react";

import { GET_TRANSACTIONS_REFERENCE } from "utils/reactQueryKeys";

import PersonalInfo from "./PersonalInfo";

import { useCustomQuery } from "store/hooks/react-query/query/useQuery";
import CustomLoader from "components/atoms/CustomLoader";

import { downloadOnClick } from "utils/exportToExcel";

import moment from "moment";

import HistorySummary from "./HistorySummary";
import PaymentMethod from "./PaymentMethod";

function TransactionHistoryDetails({ details }) {
  //get transaction
  const {
    data: transactionDetails,
    isLoading: getTransactionDetailsLoading,
    isError,
  } = useCustomQuery(
    [GET_TRANSACTIONS_REFERENCE, details?.paymentReference],
    {
      url: `/payment/transactions/?reference=${details?.paymentReference}`,
      method: "get",
    },
    {
      refetchOnWindowFocus: false,
    }
  );
  let paymentDetails = null;
  if (transactionDetails && !getTransactionDetailsLoading && !isError)
    paymentDetails = transactionDetails?.data?.[0];
  return (
    <>
      <Stack spacing={2}>
        <Stack
          direction={"row"}
          alignItems={"center"}
          justifyContent={"space-between"}
        >
          <Typography variant="displaySm" ml={{ xs: 0, md: 3.5 }}>
            Transaction Details
          </Typography>
          <CustomButton
            text="Download Receipt"
            disabled={!details?.receiptUrl}
            onClick={() =>
              downloadOnClick(
                details?.receiptUrl,
                `receipt for ${details?.patient?.firstName} ${
                  details?.patient?.lastName
                } on ${moment(new Date()).format("MMMM Do, YYYY")}`
              )
            }
            color="secondary"
            sx={{ minWidth: "150px" }}
          />
        </Stack>
        <Grid container spacing={4} mb={4}>
          <Grid item xs={12} sm={6}>
            <Stack sx={{ width: "100%" }} spacing={2}>
              {getTransactionDetailsLoading ? (
                <CustomLoader />
              ) : (
                <>
                  <PersonalInfo patientInfo={paymentDetails?.patient} />
                  <PaymentMethod
                    paymentMethod={
                      paymentDetails?.paymentMethod === "HMO" ? "hmo" : "others"
                    }
                    othersForm={{
                      reference: paymentDetails?.paymentReference,
                      type: paymentDetails?.paymentMethod,
                    }}
                    hmoProvider={paymentDetails?.hmoProvider?._id}
                    paymentStatus={"PAID"}
                  />
                </>
              )}
            </Stack>
          </Grid>
          <Grid item xs={12} sm={6}>
            {getTransactionDetailsLoading ? (
              <CustomLoader />
            ) : (
              <Stack sx={{ width: "100%" }} spacing={2}>
                <HistorySummary transactionDetails={transactionDetails?.data} />
              </Stack>
            )}
          </Grid>
        </Grid>
      </Stack>
    </>
  );
}

export default TransactionHistoryDetails;
